import {useUpdateUserNotificationPreferencesMutation} from "@/api/userApi";
import NotificationStatusOffIcon from "@/assets/colorable/notification_status_off.svg?react";
import NotificationStatusOnIcon from "@/assets/colorable/notification_status_on.svg?react";
import {type FC, memo} from "react";
import {useParams} from "react-router";

const UserNotificationToggle: FC<{userId: number; isInitiallyEnabled: boolean}> = ({userId, isInitiallyEnabled}) => {
  const {companyId} = useParams<{companyId?: string}>();

  const {mutate: updatePreferences, isPending: isUpdatingPreferences} = useUpdateUserNotificationPreferencesMutation({
    companyId: Number(companyId),
    isInitiallyEnabled,
    userId,
  });

  return (
    <button onClick={() => updatePreferences()} disabled={isUpdatingPreferences}>
      {isInitiallyEnabled ? (
        <NotificationStatusOnIcon className="text-primary-dark-solid h-auto w-12 shrink-0" />
      ) : (
        <NotificationStatusOffIcon className="text-neutral-grey-light-dark h-auto w-12 shrink-0" />
      )}
    </button>
  );
};

export default memo(UserNotificationToggle);
